import { render } from "./employee_delete_vacations_modal.vue?vue&type=template&id=596cbc6a"
import script from "./employee_delete_vacations_modal.vue?vue&type=script&lang=js"
export * from "./employee_delete_vacations_modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__